
cc.Class({
    extends: cc.Component,

    properties: {
        paytablePrefab: cc.Prefab
    }
});
